import React from 'react'
import { type GridColumns, GridList, withContainerSize } from '@retailer-platform/shared-components'
import { ErrorPage } from 'gin-and-tonic/containers/error-page/ErrorPage'
import { type usePartnerPickDevicesSearch } from 'domains/partner-pick-devices/api/partnerPickDevicesSearch.hooks'
import { type PartnerPickDeviceDatum } from 'domains/partner-pick-devices/types/partnerPickDevices.types'
import { useDomainMessage } from 'domains/partner-pick-devices/utils/domain/intl'

interface PartnerPickDevicesListProps
  extends Pick<
    ReturnType<typeof usePartnerPickDevicesSearch>,
    'apiData' | 'apiLoading' | 'apiError'
  > {
  columns: GridColumns<PartnerPickDeviceDatum>
  loadMore: () => void
  canLoadMore: boolean
  refetch: () => void
}

const ExpandableGrid = withContainerSize(GridList)

export const PartnerPickDevicesList: React.FunctionComponent<PartnerPickDevicesListProps> = ({
  columns,
  apiData,
  apiError,
  apiLoading,
  canLoadMore,
  loadMore,
  refetch,
}) => {
  const noResults = useDomainMessage('partnerPickDevicesDomain.list.noResults')

  if (apiError) {
    return <ErrorPage action={() => refetch()} />
  }

  const data = apiData ? apiData.partnerPickDeviceSearch.devices : []

  return (
    <ExpandableGrid
      columns={columns}
      data={data}
      emptyStateMessage={noResults}
      loadingMore={apiLoading}
      canLoadMore={canLoadMore}
      onLoadMore={loadMore}
    />
  )
}
